export enum Theme {
  LIGHT = 0,
  DARK = 1,
  AUTO = 2,
}
